import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import config from "./config.json";

const ShadowWrapper = ({ children, onCssReady }) => {
  const containerRef = useRef(null);
  const [shadowRoot, setShadowRoot] = useState(null);

  useEffect(() => {
    if (containerRef.current && !shadowRoot) {
      const shadow = containerRef.current.attachShadow({ mode: 'open' });
      setShadowRoot(shadow);
    }
  }, [shadowRoot]);

  // Notify when the CSS is loaded
  const handleCssLoad = () => {
    if (onCssReady) {
      onCssReady(); // Signal that CSS is ready
    }
  };

  // Inject the stylesheet into the shadow root
  const shadowStylesheet = (
    <link
      rel="stylesheet"
      href={`${config.appBaseUrl}/static/css/main.css`}
      onLoad={handleCssLoad} // Trigger callback when CSS is loaded
    />
  );

  return (
    <div ref={containerRef}>
      {shadowRoot &&
        ReactDOM.createPortal(
          <>
            {shadowStylesheet}
            {children}
          </>,
          shadowRoot
        )}
    </div>
  );
};

export default ShadowWrapper;
